module.exports = "/_next/static/images/390870d3a6b0eccb0774f3a3f6642d69-blog-lg-1x.jpg.webp";